/**
 * Normalize text for search: lowercase, NFD, strip diacritics.
 */
export const DIACRITIC_NORMALIZE_FORM = 'NFD'

export function normalizeForSearch(v) {
  return String(v ?? '')
    .toLowerCase()
    .normalize(DIACRITIC_NORMALIZE_FORM)
    .replace(/[\u0300-\u036f]/g, '')
}
